angular.module('ui.shell')
    .directive('rightPanelView', function (customTemplateResolver) {
        return {
            restrict: 'E',
            replace: 'true',
            templateUrl: 'app/ui/shell/views/rightPanel.html' //customTemplateResolver.get('rightPanel.html', 'app/ui/shell/views/rightPanel.html'),
        };
    });